import 'BomdisoftComponents/action-rows/styles.css';
import type { ActionRowGroupTone } from 'BomdisoftComponents/action-rows/render';
import { WarningRoundedIcon } from 'BomdisoftComponents/icons/warning-rounded';
import type { ReactNode } from 'react';

export type { ActionRowGroupTone } from 'BomdisoftComponents/action-rows/render';

export type ActionRowGroupProps = {
  children: ReactNode;
  heading?: string;
  /** `danger` lifts the group onto its own tinted plate, set apart from the
   * groups above it. Approved 2026-08-22. It holds ONLY actions that destroy
   * something: a reversible action inside a danger zone teaches the reader that
   * the zone does not mean what it says. */
  tone?: ActionRowGroupTone;
  shouldStackWhenNarrow?: boolean;
  testId?: string;
};

export const ActionRowGroup = ({ children, heading, shouldStackWhenNarrow = false, testId, tone = 'default' }: ActionRowGroupProps) => (
  <div className={tone === 'danger' ? 'bomdisoft-action-rows-plate' : undefined} data-testid={testId} data-tone={tone === 'danger' ? 'danger' : undefined}>
    {heading ? (
      <p className='bomdisoft-action-rows-heading'>
        {/* The icon is redundant with the heading text on purpose: colour is
            never the only thing saying this zone is different. */}
        {tone === 'danger' ? <WarningRoundedIcon aria-hidden='true' className='bomdisoft-action-rows-heading-icon' /> : null}
        {heading}
      </p>
    ) : null}
    <div className='bomdisoft-action-rows-group' data-narrow={shouldStackWhenNarrow ? 'stack' : undefined}>
      {children}
    </div>
  </div>
);

export type ActionRowProps = {
  label: ReactNode;
  meta?: ReactNode;
  chip?: ReactNode;
  action?: ReactNode;
  testId?: string;
};

export const ActionRow = ({ action, chip, label, meta, testId }: ActionRowProps) => (
  <div className='bomdisoft-action-rows-row' data-testid={testId}>
    <span className='bomdisoft-action-rows-body'>
      <span className='bomdisoft-action-rows-label'>
        {label}
        {chip}
      </span>
      {meta ? <span className='bomdisoft-action-rows-meta'>{meta}</span> : null}
    </span>
    {action ? <span className='bomdisoft-action-rows-action'>{action}</span> : null}
  </div>
);
